import {
  DEFAULT_COLUMN_HEADER_HEIGHT,
  STATISTICS_BOX_HEIGHT,
} from "../../../../../common/variables/common";
import { DataGrid, useGridApiRef } from "@mui/x-data-grid";

import SystemHealthNoRowsOverlay from "./SystemHealthNoRowsOverlay";
import { SystemPerformanceResponseModel } from "../../system-performance/models/chart";
import { Theme } from "@mui/material";
import { dataGridServerStyles } from "../../../../../common/providers/theme/design-tokens/DataGrid/dataGridServer.styles";
import { useEffect, useMemo } from "react";
import { useSystemHealthTableColumns } from "../hooks/useSystemHealthTableColumns";
import { useSystemHealthTableRows } from "../hooks/useSystemHealthTableRows";

type SystemHealthTableProps = {
  data: SystemPerformanceResponseModel[];
  loading: boolean;
  title: string;
  tableItemName: string;
};

const SystemHealthTable: React.FC<SystemHealthTableProps> = ({
  data,
  loading,
  title,
  tableItemName,
}) => {
  const eventType = useMemo(() => {
    return data.length > 0 ? data[0].event_type : undefined;
  }, [data]);

  const { columns } = useSystemHealthTableColumns(
    data,
    title,
    tableItemName,
    eventType
  );
  const { rows } = useSystemHealthTableRows(data);

  const apiRef = useGridApiRef();

  useEffect(() => {
    apiRef.current.unstable_setColumnVirtualization(false);
  }, []);

  const handleSortModelChange = () => {
    apiRef.current.scrollToIndexes({ rowIndex: 0 });
  };

  return (
    <DataGrid
      apiRef={apiRef}
      sx={{
        ...dataGridServerStyles.sx,
        border: "1px solid",
        height: STATISTICS_BOX_HEIGHT,
        borderColor: (theme: Theme) => theme.palette.otherOutlineBorder.main,
      }}
      rows={rows}
      columns={columns}
      slots={{
        noRowsOverlay: () => <SystemHealthNoRowsOverlay loading={false} />,
      }}
      columnHeaderHeight={DEFAULT_COLUMN_HEADER_HEIGHT}
      onSortModelChange={handleSortModelChange}
      disableRowSelectionOnClick
      getRowId={(row: { rowId: string }) => row.rowId}
      loading={loading}
    />
  );
};

export default SystemHealthTable;
